module.exports = __webpack_public_path__ + "img/banner4.3c324628.png";